import React from 'react'
import Main from '../components/Main'

interface IProps {
    routeName: string
}

export default ({ routeName }: IProps) => <Main routeName={routeName} />
